import styled, { keyframes } from 'styled-components';

// Styled components
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const MainContainer = styled.div` 
  padding-top:25px; 
  animation: ${fadeIn} 1s ease-in-out forwards; /* Apply the fade-in animation */
`;
export const ContainerTitle = styled.div` 
color: #000;
font-family: Product Sans;
font-size: 1.5em;
font-style: normal;
font-weight: 700;
line-height: normal;

`;
export const AcitveWorkerContainer = styled.div` 
display:flex;
flex-direction:row; 
justify-content: space-between;
width: 94%;
flex-wrap: wrap; 
`; 
export const AcitveWorkerBox = styled.div`  
    margin-top: 20px;  
    box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 8px;
    width: 49%;
    height: 72px;
    font-size: var(--font-size-3xs);
    color: var(--color-black);
    display:flex;
    flex-direction:row; 
    background: white;
    border-radius: 15px;
`;

export const AcitveWorkerImage = styled.img` 
    overflow-clip-margin: content-box;
    overflow: clip;
    padding-top: 10px;
    padding-left: 16px;
    border-radius: var(--br-xs);
    width: 64px;
    height: 54px;
    object-fit: cover;
`;
export const AcitveWorkerDetail = styled.div` 
    display:flex;
    flex-direction:column;
`;

export const AcitveWorkerName = styled.div` 
padding-top: 18px;
padding-left: 15px;
font-size: var(--font-size-sm);
letter-spacing: -0.18px;
line-height: 14.27px; 
color: var(--color-black);
font-size: 18px;
font-style: normal;
font-weight: 700;
font-family: Product Sans;
`;

export const AcitveWorkerDesignation = styled.div`  
padding-top: 1px;
padding-left: 15px;
color: #959595;
font-family: Product Sans;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 14.265px; /* 142.651% */
letter-spacing: -0.178px;
`;

export const AcitveWorkerScan = styled.div`  
padding-top:28px; 
color: #000;
font-family: Product Sans;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 14.265px; /* 142.651% */
letter-spacing: -0.178px;
width:28%;
text-align:right; 
`;
export const AcitveWorkerScanCount = styled.div`  
padding-top:28px; 
padding-left:2px; 
color: #959595;
font-family: Product Sans;
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 14.265px; /* 142.651% */
letter-spacing: -0.178px;
width:10%;

`;

export const AcitveWorkerStatus = styled.button`  
font-size: var(--font-size-3xs);
border-radius: var(--br-11xl);
background-color: var(--color-lightgreen);
width: 70px;
height: 24px;
border:none;
font-family: var(--font-product-sans);
margin:25px 20px 20px 70px;
cursor:pointer;
`;           